/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ExcelTypes {
  ReceiverNumbers = 1,
  InboxMessages = 2,
  Contacts = 3,
  InboxMessagesByPollParserId = 4,
  InboxMessagesByTextParserId = 5,
  UserOutboxMessages = 6,
  OrganizationOutboxMessages = 7,
  UsersOutboxMessages = 8,
  ResellerOutboxMessages = 9,
  Users = 10,
  Transactions = 11,
  ResellerTransactions = 12,
  Payments = 13,
  SmartSmsStatistics = 14,
  InquireBlackList = 15,
  LegalOrganizations = 16,
  PersonalOrganizations = 17,
  SmartSmsRequests = 18,
  SmartSmsRequestRecipients = 19,
  FormBuilderResponses = 20
}
